<!-- 
    The div with tabindex is there for a reason: it means p-datepicker, showOnFocus can be set to true.
    This stops the datepicker auto focusing (so opening when landing on certain components).
    Then when you are in a modal i.e. admin - events - working hours, and you click to change the hours, the dropdown does not auto close
-->

<div class="position-relative" tabindex="-1">
    <div class="input-group" (onInputClick)="dp.toggle()">
        <p-datepicker
            #dp
            panelStyleClass="kui-datetime"
            [inputStyleClass]="inputStyle()"
            [ngModel]="dateInstance()"
            (onSelect)="update($event)"
            (onFocus)="setFocussedState(true)"
            (onClose)="setFocussedState(false)"
            [minDate]="minInstance()"
            [maxDate]="maxInstance()"
            [hourFormat]="hourDisplayFormat()"
            [showSeconds]="timeIsDisplayed()"
            [timeOnly]="type() === 'time'"
            [showTime]="timeIsDisplayed()"
            [hideOnDateTimeSelect]="false"
            [dateFormat]="dateDisplayFormat()"
            [disabled]="disabled()"
            [readonlyInput]="true"
            [showOnFocus]="showOnFocus()"
            [showIcon]="false"
            [touchUI]="false"
            [appendTo]="appendTo()"
            [baseZIndex]="2030"
            [placeholder]="placeholder()"
        >
        </p-datepicker>
        <span
            class="input-group-text"
            [class.form-builder]="inputStyle() === 'form-builder'"
            [class.content-header-bar]="inputStyle() === 'content-header-bar'"
            (click)="dp.toggle()"
            readonly
        >
            @if (icon() !== "none") {
                <kui-icon [name]="icon() || type() === 'time' ? 'clock' : 'calendar'"></kui-icon>
            }
        </span>
    </div>
</div>
